export function Disclaimer() {
  return (
    <div>
      <div className="row">
        <div className="col-sm-12">
          <h2 style={{ marginTop: '15px' }}>More About the Wild Horse and Burro Stewardship Program</h2>
          <p>
            Donations through the Wild Horse and Burro Stewardship Program support the management and protection of wild horses and burros under
            the <a href="https://www.blm.gov/programs/wild-horse-and-burro/about-the-program/program-history" target="_blank" rel="noreferrer">Wild Free-Roaming Horses and Burros Act</a>.
            When herds become too large, the BLM may use funds to remove some horses and burros from the land. These animals are
            then placed in adoption programs across the country to find them good homes. In the meantime, BLM provides excellent care for the animals
            in corrals, ensuring they have good food, water, and everything else they need. For animals that aren't adopted, BLM manages them in pastures.
            Your donations support all these activities, along with scientific research to help the BLM continuously improve its wild horse and burro
            management practices.
          </p>
        </div>
      </div>
    </div>
  )
}